import CollectionDetails from './CollectionDetails';

export default CollectionDetails;
